import { useFetch } from '@reveni-io/reveni-ui'

import { noPaginationParams } from '@/common/constants'
import configurationServices from '@/configuration/services/services'

import { transformResponseVisibilityCriteriaOptions } from './transformers'

const useVisibilityCriteriaOptions = ({ storeId }) => {
  const { data, loading } = useFetch(configurationServices.getVisibilityCriteria, {
    doInitialRequest: true,
    params: { storeId, ...noPaginationParams },
    transformResponse: transformResponseVisibilityCriteriaOptions,
  })

  return { criteriaOptions: data || [], loadingCriteriaOptions: loading }
}

export default useVisibilityCriteriaOptions
